import {Tooltip} from '@yandex-lego/components/esm/Tooltip/desktop/bundle/index';
import block from 'bem-cn-lite';
import React, {FC, ReactNode, RefObject, useRef, useState} from 'react';

import './index.scss';

const b = block('plus-button');

type ResearchTextProps = {
  tooltipText: ReactNode;
  parentDivRef: RefObject<HTMLElement>;
};

const PlusButton: FC<ResearchTextProps> = ({tooltipText, parentDivRef}) => {
  const [isVisible, setIsVisible] = useState(false);
  const anchorRef = useRef(null);

  const handleClick = React.useCallback(() => setIsVisible(!isVisible), [isVisible]);
  const handleClose = React.useCallback(() => setIsVisible(false), []);

  return (
    <div className={b()}>
      <button className={b('plus')} ref={anchorRef} onClick={handleClick} title="Что это значит?">
        <span>+</span>
      </button>
      <Tooltip
        anchor={anchorRef}
        visible={isVisible}
        direction={['bottom-center', 'bottom-left']}
        className={b('tooltip')}
        zIndex={10}
        scope={parentDivRef}
        onClose={handleClose}
      >
        {tooltipText}
      </Tooltip>
    </div>
  );
};

export default PlusButton;
